import { Notification } from '@lib/graphql/__generated__/graphql'
import { TFunction } from '@translations/useTranslations'
import { formatDate } from '@utils/Date'
import { formatDisplayedEmail } from '@utils/Email'
import { isToDo } from '@utils/Task'
import { NOTIFICATION_ACTIONS, parseNotificationText } from './utils'

export const commentNotifications = (t: TFunction) => ({
  [NOTIFICATION_ACTIONS.COMMENT_LIKE]: (data: Notification) => {
    const getCommentContext = () => {
      if (data.comment?.task) {
        return { text: t('expressions.onTask'), name: data.comment.task.name }
      }
      if (data.comment?.thread) {
        return {
          text: t('expressions.onThread'),
          name: data.comment.thread.title,
        }
      }
      if (data.comment?.goal) {
        return { text: t('expressions.onGoal'), name: data.comment.goal.name }
      }
      return null
    }

    const context = getCommentContext()

    return (
      <>
        {data.actor?.fullName ?? ''} {t('expressions.likedYourComment')}
        {context && (
          <>
            {' '}
            {context.text}{' '}
            <span className="font-semibold">{`"${context.name}"`}</span>
          </>
        )}
      </>
    )
  },

  [NOTIFICATION_ACTIONS.NEW_COMMENT]: (data: Notification) => {
    const { inboundEmailEnvelope } = data?.comment || {}

    const from = inboundEmailEnvelope?.from
    const fromName = from
      ? formatDisplayedEmail(from.email, from.name)
      : (data?.actor?.fullName ?? '')

    return (
      <>
        {fromName}{' '}
        {data.comment?.goal
          ? t('expressions.commentedOnGoal')
          : isToDo(data.comment?.task)
            ? t('expressions.commentedOnToDo')
            : t('expressions.commentedOnTask')}{' '}
        <span className="font-semibold">{`"${parseNotificationText(
          data.comment?.task?.name ?? data.comment?.goal?.name,
          70,
        )}"`}</span>
      </>
    )
  },
})

export const commentReplyNotifications = (t: TFunction) => ({
  [NOTIFICATION_ACTIONS.NEW_COMMENT]: (data: Notification) => (
    <>
      {data.actor?.fullName ?? ''}{' '}
      {data.comment?.goal
        ? t('expressions.repliedToYourCommentOnGoal')
        : isToDo(data.comment?.task)
          ? t('expressions.repliedToYourCommentOnToDo')
          : t('expressions.repliedToYourCommentOnTask')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        data.comment?.task?.name ?? data.comment?.goal?.name,
        70,
      )}"`}</span>
    </>
  ),
})

export const commentReminderNotifications = (t: TFunction) => ({
  [NOTIFICATION_ACTIONS.COMMENT_REMINDER]: (data: Notification) => (
    <>
      {t('expressions.reminderForComment')} {formatDate(data.createdAt, true)}
    </>
  ),
})
